import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Register, User } from '../_model/login';
import { AuthService } from '../_services/auth.service';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';


@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.less'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  faTrash = faTrash;
  faEdit = faEdit;

  constructor(private auth: AuthService) { }

  model: Register = new Register();

  list: User[] = [];

  error: any = {
    email: false
  };

  ngOnInit() {    
    this.model.userId = localStorage.getItem("userId");
    this.auth.list(this.model.userId).subscribe((data: User[]) => {
      data.forEach(el => {
        this.list.push(new User(el));
      });
    });
  }

  bind(item: User) {
    this.model = new Register(item);
    this.model.userId = localStorage.getItem("userId");
  }

  checkEmail() {
    if(this.model.email == '' || this.model.email == null || this.model.email == undefined)
      return;
    this.auth.email(this.model.email, this.model.userId, this.model.id).subscribe((data: boolean) => {
      this.error.email = !data;
    });
  }


  clear() {
    this.model = new Register();
    this.model.userId = localStorage.getItem("userId");
  }

  delete(item: User) {
    Swal.fire({
      title: "Tem a certeza que pretende eliminar o utilizador?",
      text: "Se continuar com esta ação irá eliminar "+item.nome+" da base de dados",
      icon: 'warning',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      customClass: {
        confirmButton: "btn red base",
        cancelButton: "btn green base"
      }
    }).then((result) => {
      if(result.isConfirmed) {
        Swal.fire({
          title: "Utilizador Eliminado com sucesso",
          text: "O utilizador "+item.nome+" foi eliminado da base de dados",
          icon: 'success'
        });        
        this.auth.delete(item.id,localStorage.getItem("userId")).subscribe(() => {
          this.clear();
          
          this.list = [];
          this.auth.list(this.model.userId).subscribe((data: User[]) => {
            data.forEach(el => {
              this.list.push(new User(el));
            });
          });
        })
      }
    });
  }

  send() {
    if(this.error.email)
      return;
    if(this.model.nome == '') {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o nome do Funcionário</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.email == ''){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o Email do Funcionário</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else {
      this.auth.register(this.model).subscribe(() => {
        this.list = [];
        this.auth.list(this.model.userId).subscribe((data: User[]) => {
          data.forEach(el => {
            this.list.push(new User(el));
          });
        });
        if(this.model.id > 0) {
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Funcionário actualizado com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }else{
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Funcionário inserido com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }
        this.clear();
      });
    }
  }

}
